import React from 'react';
import { Box, Checkbox, FormControlLabel, Badge } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

interface Props {
	showChecked?: boolean;
	onToggle?: () => void;
	textKey: string;
	badgeCount?: number;
	badgeCountLimit?: number;
}

const RentalSearchBarFilterCheckbox = (props: Props) => {
	const { showChecked, onToggle, textKey, badgeCount, badgeCountLimit } = props;
	const classes = useStyles();
	return (
		<Box className={classNames(classes.filterWrapper, classes.checkBoxBoxes)}>
			<FormControlLabel
				control={
					<Checkbox
						color="primary"
						className={classes.noMarginPadding}
						checked={showChecked}
						onChange={onToggle}
					/>
				}
				label={
					<Badge
						classes={{
							root: classes.badgeRoot,
							badge: classes.badge,
							invisible: classes.invisibleBadge,
						}}
						color="primary"
						invisible={!badgeCount}
						badgeContent={
							badgeCountLimit
								? (badgeCount || 0) >= badgeCountLimit
									? badgeCountLimit + '+'
									: badgeCount
								: badgeCount
						}
					>
						<span className={classes.tabText}>{textKey}</span>
					</Badge>
				}
				classes={{
					root: classNames(classes.noMarginPadding, classes.heights),
					label: classes.marginLeft,
				}}
			/>
		</Box>
	);
};
const useStyles = makeStyles((theme) => {
	const border = `1px solid ${theme.palette.colors.tundra.main}`;

	return createStyles({
		filterWrapper: {
			flex: '0 1 auto',
			flexWrap: 'wrap',
			paddingLeft: theme.spacing(2),
			borderLeft: border,
			'@media (max-width:880px)': {
				flex: '1 0 auto',
			},
		},
		marginLeft: {
			marginLeft: 8,
		},
		checkBoxBoxes: {
			paddingRight: 16,
		},
		heights: {
			height: 40,
		},
		badgeRoot: {
			height: '100%',
			verticalAlign: 'text-top',
		},
		badge: {
			position: 'relative',
			top: '12px',
			left: '-5px',
			color: theme.palette.colors.tundra.dark,
			backgroundColor: 'transparent',
			border: `1px ${theme.palette.colors.tundra.main} solid`,
		},
		invisibleBadge: {
			position: 'absolute',
		},
		tabText: {
			whiteSpace: 'nowrap',
			textAlign: 'start',
			display: 'flex',
			alignItems: 'center',
			fontSize: 14,
		},
		noMarginPadding: {
			margin: 0,
			padding: 0,
		},
	});
});
export default RentalSearchBarFilterCheckbox;
